import { Controller } from "react-hook-form";
import { fontSizes } from "../../constants/constants";
import Text from "../Text";
import Functions from "./index.function";
function FormInput({
  control,
  name,
  userData,
  type,
  icon,
  iconStyle,
  cardIcon,
  label,
  sublabel,
  pattern,
  maxLength,
  placeholder,
  isRequired,
  isMandatory,
  validate,
  errors,
  is_ForgotPassword,
  isPassword = false,
  isdisabled = false,
  iconPasswordVisible,
  iconPasswordHidden,
  ...props
}) {
  const {
    TextWeight,
    value,
    setValue,
    isPasswordVisible,
    inputRef,
    handleFocusInput,
    togglePasswordVisibility,
    navigate,
  } = Functions(userData, type, name);

  return (
    <div className="mx-[2px]">
      {label && (
        <Text
          text={
            <>
              {label}
              {sublabel && <Text text={sublabel} color="text-gray ml-0.5" />}
            </>
          }
          size={fontSizes.h16}
          weight={TextWeight.Onest_regular}
          isRequired={isMandatory}
          color="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary"
        />
      )}
      <div className="relative">
        <Controller
          control={control}
          name={name}
          defaultValue={value}
          rules={{
            ...(
              props.rules
                ? props.rules
                : isRequired
                ? { required: `${label} is required` }
                : {}
            ),
            ...(pattern ? { pattern } : {}),
            ...(maxLength
              ? {
                  maxLength: {
                    value: maxLength,
                    message: `${label} cannot exceed ${maxLength} characters`,
                  },
                }
              : {}),
            ...(validate ? { validate } : {}),
          }}
            render={({ field }) => (
            <input
              className={`xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic ${
                isdisabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
              type={isPassword ? (isPasswordVisible ? "text" : "password") : type}
              {...field}
              {...props}
              value={value}
              placeholder={placeholder || "Type here..."}
              maxLength={maxLength}
              onChange={(e) => {
                field.onChange(e);
                setValue(e.target.value);
              }}
              disabled={isdisabled}
              ref={inputRef}

              max={type === "date" ? new Date().toISOString().split("T")[0] : undefined}

              // ✅ ensure date picker opens properly on focus
              onFocus={(e) => {
                if (type === "date" && e.target.showPicker) e.target.showPicker();
              }}
            />

          )}
        />
        {icon && (
          <img
            onClick={handleFocusInput}
            className={`absolute left-5 3xl:left-8 top-1/2 transform -translate-y-1/2 ${iconStyle}`}
            src={icon}
            alt={`${name} icon`}
          />
        )}
        {cardIcon && (
          <img
            onClick={() => {
              handleFocusInput();
              if (inputRef.current && type === "date") {
                inputRef.current.showPicker();
              }
            }}
            className={`absolute xs:right-14 right-16 top-1/2 transform -translate-y-1/2`}
            src={cardIcon}
            alt={`${name} cardIcon`}
          />
        )}
        {isPassword && (
          <img
            className="absolute right-5 top-1/2 transform -translate-y-1/2 xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-6 w-7 cursor-pointer 3xl:right-8 3xl:w-8 3xl:h-7"
            src={isPasswordVisible ? iconPasswordVisible : iconPasswordHidden}
            alt={isPasswordVisible ? "Show password" : "Hide password"}
            onClick={togglePasswordVisibility}
          />
        )}
      </div>
      <div
        className={`${
          is_ForgotPassword
            ? "flex justify-between items-start"
            : "flex justify-start items-start"
        }`}
      >
        <div>
          {errors?.[name] && (
            <Text
              text={errors[name].message}
              color="text-orangeCrayola"
              size={fontSizes.h14}
              textWeight={TextWeight.Onest_regular}
              className={"xs:pl-6 sm:pl-6 lg:pl-8"}
              isTruncate={false}
            />
          )}
        </div>
        {is_ForgotPassword && (
          <Text
            text="Forgot Password"
            color="text-secondary"
            size={fontSizes.h14}
            className="cursor-pointer hover:text-orangeCrayola hover:underline pr-6 sm:pr-6 lg:pr-8"
            onClick={() => {
              navigate("/forget-password");
            }}
          />
        )}
      </div>
    </div>
  );
}

export default FormInput;
